import React                             from 'react';
import classNames                        from 'classnames';
import { Observe }                       from 'rewire-core';
import { Theme, CSSTheme }               from 'rewire-ui';
import { makeStyles }                    from '@material-ui/core/styles';
import Button                            from '@material-ui/core/Button';
import RefreshIcon                       from '@material-ui/icons/Refresh';
import SecondaryFilterIcon               from '@material-ui/icons/Details';
import Breadcrumbs                       from '../main-navigation/Breadcrumbs';
import MainContentToolbar                from '../main-navigation/MainContentToolbar';
import ScheduleControls                  from '../schedule/ScheduleControls';
import MainDateRangeNav                  from '../ui/MainDateRangeNav';
import ReportFormats                     from './ReportFormats';
import ReportOptions                     from './ReportOptions';
import ReportSecondaryFiltersDialog      from './ReportSecondaryFilterDialog';
import reportSecondaryFilterDialogModel  from './ReportSecondaryFilterDialogModel';
import reportModel                       from './ReportModel';

const styles = (theme: Theme) => ({
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 1 auto',
    flexWrap: 'wrap',
  },
  button: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '5px',
    marginBottom: '7px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
  refreshReportButton: {
    minWidth: '24px',
    padding: '4px 8px',
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.light,
    },
  },
  secondaryFiltersButton: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
  },
  hasSelection: {
    color: theme.palette.secondary.main
  },
}) as CSSTheme;

const useReportToolbarStyles = makeStyles(styles);

export default (props: any) => {
  const classes = useReportToolbarStyles(props);

  return <Observe render={() => {
    const hideDate            = !reportModel.allowDate();
    const hideDuration        = !reportModel.allowDuration();
    const hideFilterBy        = !reportModel.allowFiltering();
    const hideGroupBy         = !reportModel.allowGrouping();
    const hideSortBy          = !reportModel.allowSorting();
    const hasPermittedFilters = reportSecondaryFilterDialogModel.hasPermittedFilters;
    const hasFilters          = reportSecondaryFilterDialogModel.hasFilters;
    return (
      <MainContentToolbar>
        <div className={classes.left}>
          <Breadcrumbs />
          <MainDateRangeNav hideDate={hideDate} hideDuration={hideDuration} />
        </div>
        <div className={classes.right}>
          <Button title='Refresh Report' className={classNames(classes.button, classes.refreshReportButton)} disabled={!reportModel.canRefresh()} variant='contained' onClick={reportModel.refreshReport}>
            <RefreshIcon />
          </Button>
          <ReportFormats />
          <ReportOptions />
          {!hasPermittedFilters
            ? null
            : <Button title='Secondary Filters' className={classNames(classes.button, classes.secondaryFiltersButton, hasFilters ? classes.hasSelection : undefined)} onClick={() => reportSecondaryFilterDialogModel.showSecondaryFilters()}>
                <SecondaryFilterIcon />
              </Button>
          }
          <ScheduleControls hideFilterBy={hideFilterBy} hideGroupBy={hideGroupBy} hideSortBy={hideSortBy} />
        </div>
        <ReportSecondaryFiltersDialog />
      </MainContentToolbar>
    );
  }} />;
};
